module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a2287c8fce6d430522b550e223678c6a.png";